module.exports = __webpack_public_path__ + "static/media/YM46_0.0c5d6bfb.jpg";